import React, { useState } from "react";
import PropTypes from "prop-types";
import CardDelete from "./CardDelete";

// components
import Spinner from "components/Spinner/Spinner";

import EditIcon from "@material-ui/icons/Edit";
import MergeTypeIcon from "@material-ui/icons/MergeType";
import { Link, useRouteMatch } from "react-router-dom";

export default function CardTable({
  color,
  tableData,
  tableHeaderArr,
  columnNamesArr,
  name,
  status,
  deleteCard,
}) {
  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [dataPerPage] = useState(10);
  const totalRecords = tableData?.length;
  const last = currentPage * dataPerPage;
  const start = last - dataPerPage;
  const currentData = tableData?.slice(start, last);
  const pageNumbers = [];
  if (totalRecords) {
    for (let i = 1; i <= Math.ceil(totalRecords / dataPerPage); i++) {
      pageNumbers.push(i);
    }
  }

  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const previousPage = () => setCurrentPage(currentPage - 1);
  const nextPage = () => setCurrentPage(currentPage + 1);
  let match = useRouteMatch();
  return (
    <>
      <div
        className={
          "relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded " +
          (color === "light" ? "bg-white" : "bg-blue-900 text-white")
        }
      >
        <div className="rounded-t mb-0 px-4 py-3 border-0">
          <div className="flex flex-wrap items-center">
            <div className="relative w-full px-4 max-w-full flex-grow flex-1">
              <h3
                className={
                  "font-semibold text-lg " +
                  (color === "light" ? "text-gray-800" : "text-white")
                }
              >
                {name}
              </h3>
            </div>
          </div>
        </div>
        <div className="block w-full overflow-x-auto">
          {/* Projects table */}
          <table className="items-center w-full bg-transparent border-collapse">
            <thead>
              <tr>
                {tableHeaderArr.map((header, index) => (
                  <th
                    className={
                      "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-no-wrap font-semibold text-left " +
                      (color === "light"
                        ? "bg-gray-100 text-gray-600 border-gray-200"
                        : "bg-blue-800 text-blue-300 border-blue-700")
                    }
                  >
                    {header}
                  </th>
                ))}
                <th
                  className={
                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-no-wrap font-semibold text-center " +
                    (color === "light"
                      ? "bg-gray-100 text-gray-600 border-gray-200"
                      : "bg-blue-800 text-blue-300 border-blue-700")
                  }
                >
                  ACTION
                </th>
              </tr>
            </thead>
            <tbody>
              {currentData?.map((data, index) => (
                <tr className="hover:bg-purple-200 cursor-pointer">
                  {columnNamesArr.map((name, index) => (
                    <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-base whitespace-no-wrap p-4">
                      {data[name]}
                    </td>
                  ))}

                  <td className="border-t-0 flex px-6 align-middle border-l-0 border-r-0 text-xs whitespace-no-wrap p-4 text-center">
                    <Link to={`${match.url}/edit/${data.id}`}>
                      <EditIcon
                        style={{ margin: "0 0.5rem", fontSize: "20px" }}
                      />
                    </Link>
                    <CardDelete itemId={data.id} deleteCard={deleteCard} />
                    <MergeTypeIcon
                      style={{ margin: "0 0.5rem", fontSize: "20px" }}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="pagination">
            <div className="pagination__pages">
              {pageNumbers?.length > 0 && currentPage >= 2 && (
                <button onClick={previousPage}>Prev</button>
              )}
              {pageNumbers.map((number) => (
                <button
                  key={number}
                  onClick={() => paginate(number)}
                  className="pagination__btn"
                >
                  {number}
                </button>
              ))}
              {pageNumbers?.length > 0 &&
                currentPage !== pageNumbers?.length && (
                  <button onClick={nextPage}>Next</button>
                )}
            </div>
            {pageNumbers.length > 0 && (
              <div className="pagination__cta">
                <span>PAGE</span>
                <div className="pagination__cta__page">
                  <span>{currentPage}</span>
                </div>
                <p>OF {pageNumbers.length}</p>
              </div>
            )}
          </div>
          {status === "loading" && (
            <div className="loading_spinner">
              <Spinner />
            </div>
          )}
          {status !== "loading" && status !== "finished" ? (
            <div className="loading_spinner">{status}</div>
          ) : (
            ""
          )}
        </div>
      </div>
    </>
  );
}

CardTable.defaultProps = {
  color: "light",
};

CardTable.propTypes = {
  color: PropTypes.oneOf(["light", "dark"]),
};
